import Vue from 'vue'

let outsideClickHandler: EventListener

export default Vue.directive('closable', {
  bind (el, binding, vnode) {

    outsideClickHandler = (e: Event) => {
      e.stopPropagation()

      const { handler, exclude, checkOutsideElements } = binding.value

      // eslint-disable-next-line
      const context = vnode.context as any

      let clickedOnExcludedEl = false
      exclude.forEach((refName: string) => {
        if (!clickedOnExcludedEl) {
          const excludedEl = (context?.$refs[refName] as Vue)?.$el || context?.$refs[refName]

          if (checkOutsideElements) {
            const outsideElements = context?.$parent?.$children as Vue[]
            const excludedOutsideElRef = outsideElements?.find(element => element.$refs[refName])
            const excludedOutsideEl = excludedOutsideElRef?.$el || excludedOutsideElRef

            clickedOnExcludedEl = excludedEl?.contains(e.target as Element) || (excludedOutsideEl as Element)?.contains(e.target as Element)
          } else {
            clickedOnExcludedEl = excludedEl?.contains(e.target as Element)
          }
        }
      })

      if (!el.contains(e.target as Element) && !clickedOnExcludedEl) {
        context[handler]()
      }
    }
    document.addEventListener('click', outsideClickHandler)
    document.addEventListener('touchstart', outsideClickHandler)
  },

  unbind () {
    document.removeEventListener('click', outsideClickHandler)
    document.removeEventListener('touchstart', outsideClickHandler)
  }
})
